/* eslint-disable arrow-body-style */
import {
  Stack,
  TextField,
  Button,
  Container,
  Typography,
  Paper,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  LinearProgress,
  FormControl,
  Autocomplete,
  InputLabel,
  Select,
  MenuItem,
  Grow,
  Collapse,
  Snackbar,
  Alert,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import * as XLSX from 'xlsx';
import { Label } from 'reactstrap';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LockResetIcon from '@mui/icons-material/LockReset';
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import JsPDF from 'jspdf';
import 'jspdf-autotable';
import XLSXS from 'xlsx-js-style';
import numeral from 'numeral';
import { ReactComponent as MastersIcon } from '../media/filter.svg';
import axios from '../axiosConfig';

// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '800',
  // textAlign: 'center',
  backgroundColor: '#219C90',
  padding: 'none',
  whiteSpace: 'nowrap',
});

function formatDate(inputDateTime) {
  const isoDate = new Date(inputDateTime);

  const day = isoDate.getUTCDate().toString().padStart(2, '0');
  const month = (isoDate.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = isoDate.getUTCFullYear();

  let hour = isoDate.getUTCHours();
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour %= 12;
  hour = hour || 12; // Convert 0 to 12

  const minute = isoDate.getUTCMinutes().toString().padStart(2, '0');

  return `${day}/${month}/${year} ${hour}:${minute} ${ampm}`;
}

// Set the initial state for fromDate and toDate
const formatDateToinitialValues = (date) => {
  if (!date) {
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
// Get the current date and 30 days before the current date
const currentDate = new Date();
const fromDateOnCurrentMonth = new Date(currentDate);
fromDateOnCurrentMonth.setDate(1);
// Convert fromDate and toDate objects to formatted date strings
const initialFromDate = formatDateToinitialValues(fromDateOnCurrentMonth);
const initialToDate = formatDateToinitialValues(currentDate);

function formatDateDob(inputDateTime) {
  const isoDate = new Date(inputDateTime);

  const day = isoDate.getUTCDate().toString().padStart(2, '0');
  const month = (isoDate.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = isoDate.getUTCFullYear();

  let hour = isoDate.getUTCHours();
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour %= 12;
  hour = hour || 12; // Convert 0 to 12

  const minute = isoDate.getUTCMinutes().toString().padStart(2, '0');

  return `${day}/${month}/${year}`;
}

const SwitchContainer = ({ children }) => (
  <Stack direction="row" justifyContent="start" alignItems="center" spacing={1}>
    {children}
  </Stack>
);

const DailySkillMatrix = () => {
  // eslint-disable-next-line no-restricted-globals
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';

  // At the beginning of the component
  const [fromDate, setfromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);
  const [styleData, setstyleData] = useState([]);
  const [styleSelected, setStyleSelected] = useState({
    Srhid: '0',
    StyleDescription: 'All',
        StyleNumber: '',
    Line_Name: '',
  });
  const [unitData, setUnitData] = useState([]);
  const [unitSelected, setUnitSelected] = useState({
    Unit_Id: '0',
    Unit_Name: 'All',
  });
  const [lineData, setLineData] = useState([]);
  const [lineSelected, setLineSelected] = useState({
    Line_id: '0',
    Line_Name: 'All',
  });
  const [OperationData, setOperationData] = useState([]);
  const [opSelected, setOpSelected] = useState({
    OperationId: '0',
    OperationName: 'All',
  });
  const [OperatorsData, setOperatorsData] = useState([]);
  const [operatorSelected, setOperatorSelected] = useState({
    UserAccessID: '0',
    UserName: 'All',
  });
  const [reportType, setReportType] = useState('all');
  const [reportData, setreportData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [totalSum, setTotalSum] = useState('');

    const[overall,setOverall]=useState(false)
   const[summary,setSummary]=useState(false)
     const [styleVisible,setStyleVisible] = useState(false)
     const [summaryVisible,setSummaryVisible] = useState(false)

  const groupedPaymentsByName = {};

  const resetFilters = () => {
    setfromDate(initialFromDate);
    setToDate(initialToDate);
    setStyleSelected({
      Srhid: '0',
      StyleDescription: 'All',
          StyleNumber: '',
    Line_Name: '',
    });
    setUnitSelected({ Unit_Id: '0', Unit_Name: 'All' });
    setLineSelected({
      Line_id: '0',
      Line_Name: 'All',
    });
    setOpSelected({
      OperationId: '0',
      OperationName: 'All',
    });
    setOperatorSelected({
      UserAccessID: '0',
      UserName: 'All',
    });
    setOverall(false);
    setSummary(false);
    setFilteredData([]);
  };

  // other states
  const [openLoader, setOpenLoader] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showNoResultsSnackbar, setShowNoResultsSnackbar] = useState(false);
  const noResultsMessage = 'No results found for the applied filters.';
  const [expanded, setExpanded] = React.useState(true);
  // pagination
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1));

  // API Integration
  useEffect(() => {
    GetAllActiveProductionUnits();
    // GetAllActiveLineMstData();
    GetAllActiveOperationMst();
    GetAllOperators();
    getAllStyles();
    formatDateToinitialValues();
    // getAllData();
  }, [reportType]);

  // get all Cities Request
  const getAllData = async () => {
    // setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetallPaymentsForMIS', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setreportData(res.data);
      // console.log('all data recieved: ', res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Style data
  const getAllStyles = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/getAllDailyStyles', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setstyleData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handlehidevisible =()=>{
  if(!summary){
  setStyleVisible(true)
}
else{
   setStyleVisible(false)
}
}
   const getStyles = async () => {
      setOpenLoader(true);
      try {
        const res = await axios.instance.get('/getStyles', {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        setstyleData(res.data);
        setOpenLoader(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
   
    const handleStyleFilter = (overall)=>{
      setOpenLoader(true);
      console.log(overall,'overall');
      
       if(overall)
        { 
          getStyles() 
        }
       else 
        { 
        getAllStyles() 
      }
        setOpenLoader(false);
    }

  // get all unit data
  const GetAllActiveProductionUnits = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setUnitData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all line data
  const GetAllActiveLineMstData = async (id) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveLineMstData/${sessionStorage.getItem('UserID')}/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setLineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Operation Request
  const GetAllActiveOperationMst = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveOperationMst', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOperationData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Operators Request
  const GetAllOperators = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllOperators', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOperatorsData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // handleDownloadExcel
  // const handleDownloadExcelProfileWise = () => {
  //   const data = filteredData.map((enq, index) => ({
  //     'S.No': index + 1,
  //     'Admission ID': enq.Admissionid,
  //     'Admission Date': formatDate(enq.PaymentDate),
  //     Name: `${enq.FirstName} ${enq.LastName}`,
  //     'Course Category': enq.Course_Category,
  //     Course: enq.Course_Name,
  //     'Course Fee ₹': enq.Course_Fee,
  //     'Offered Fee ₹': enq.OfferedFee,
  //     'Total Paid ₹': enq.TotalPaidAmount,
  //     'Balance Fee ₹': enq.BalanceFee,
  //     'Last Payment Date': formatDate(enq.PaymentDate),
  //   }));

  //   const wb = XLSXS.utils.book_new();
  //   const ws = XLSXS.utils.json_to_sheet(data, { origin: 'A8' });
  //   const columns = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
  //   const maxColWidths = {};
  //   const title = 'Payments Summary Report';

  //   // SETTING UP WIDTH DYNAMICALLY
  //   data.forEach((row) => {
  //     for (const col in row) {
  //       if (Object.prototype.hasOwnProperty.call(row, col)) {
  //         const cellValue = row[col] ? row[col].toString() : '';
  //         maxColWidths[col] = Math.max(maxColWidths[col] || 0, cellValue.length + 15);
  //       }
  //     }
  //   });

  //   const wscols = Object.keys(maxColWidths).map((col) => ({ wch: maxColWidths[col] }));

  //   ws['!cols'] = wscols;

  //   // Merging cells for the title
  //   ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 10 } }]; // Merging cells A1 to K2

  //   // Set the title cell's value and styling
  //   ws.A1 = {
  //     v: title,
  //     t: 's',
  //     s: {
  //       font: { bold: true, sz: 16 },
  //       alignment: { horizontal: 'center', vertical: 'center' },
  //       fill: { fgColor: { rgb: 'CCFFCC' } },
  //     },
  //   };

  //   ws.C4 = { v: 'Name: ', t: 's', s: { font: { bold: true } } };
  //   ws.D4 = { v: filters.name === '' ? 'ALL Names' : filters.name, t: 's' };

  //   ws.E4 = { v: 'Payment Status: ', t: 's', s: { font: { bold: true } } };
  //   ws.F4 = { v: filters.paymentStatus === '' ? 'ALL' : filters.paymentStatus, t: 's' };

  //   ws.C5 = { v: 'Course Category: ', t: 's', s: { font: { bold: true } } };
  //   ws.D5 = { v: filters.courseCategory === '' ? 'ALL' : filters.courseCategory, t: 's' };

  //   ws.E5 = { v: 'Course: ', t: 's', s: { font: { bold: true } } };
  //   ws.F5 = { v: filters.course === '' ? 'ALL' : filters.course, t: 's' };

  //   ws.C6 = { v: 'From Date: ', t: 's', s: { font: { bold: true } } };
  //   ws.D6 = { v: formatDateDob(fromDate), t: 's' };

  //   ws.E6 = { v: 'To Date: ', t: 's', s: { font: { bold: true } } };
  //   ws.F6 = { v: formatDateDob(toDate), t: 's' };

  //   // headers row styling
  //   const headerRowIndex = '8';
  //   columns.forEach((col) => {
  //     const cell = `${col}${headerRowIndex}`;
  //     // console.log("cell",cell );
  //     ws[cell].s = {
  //       fill: { fgColor: { rgb: 'CCFFCC' } },
  //       alignment: { horizontal: 'center' },
  //       font: { bold: true, sz: 12 },
  //       border: {
  //         left: { style: 'thin', color: { rgb: 'black' } },
  //         top: { style: 'thin', color: { rgb: 'black' } },
  //         right: { style: 'thin', color: { rgb: 'black' } },
  //         bottom: { style: 'thin', color: { rgb: 'black' } },
  //       },
  //     };
  //   });

  //   // excel table contents numbers
  //   const PriceCellStyle = {
  //     alignment: { horizontal: 'right' },
  //     border: {
  //       left: { style: 'thin', color: { rgb: 'black' } },
  //       top: { style: 'thin', color: { rgb: 'black' } },
  //       right: { style: 'thin', color: { rgb: 'black' } },
  //       bottom: { style: 'thin', color: { rgb: 'black' } },
  //     },
  //   };
  //   for (let i = 1; i <= data.length; i += 1) {
  //     const rowNumber = i + 8;
  //     ['G', 'H', 'I', 'J'].forEach((col) => {
  //       const cell = `${col}${rowNumber}`;
  //       ws[cell].s = PriceCellStyle;
  //     });
  //   }

  //   // excel table contents strings
  //   const VarCellStyle = {
  //     alignment: { horizontal: 'left' },
  //     border: {
  //       left: { style: 'thin', color: { rgb: 'black' } },
  //       top: { style: 'thin', color: { rgb: 'black' } },
  //       right: { style: 'thin', color: { rgb: 'black' } },
  //       bottom: { style: 'thin', color: { rgb: 'black' } },
  //     },
  //   };
  //   for (let i = 1; i <= data.length; i += 1) {
  //     const rowNumber = i + 8;
  //     ['A', 'B', 'C', 'D', 'E', 'F', 'K'].forEach((col) => {
  //       const cell = `${col}${rowNumber}`;
  //       ws[cell].s = VarCellStyle;
  //     });
  //   }

  //   XLSXS.utils.book_append_sheet(wb, ws, 'Payments Summary');
  //   XLSXS.writeFile(wb, `Payments Summary ${formatDateToinitialValues(new Date())}.xlsx`);
  // };

  // const handleDownloadExcelaLL = () => {
  //   const data = filteredData.map((enq, index) => ({
  //     'S.No': index + 1,
  //     'Payment ID': enq.PaymentId,
  //     'Payment Date': formatDate(enq.PaymentDate),
  //     'Admission ID': enq.Admissionid,
  //     Name: `${enq.FirstName} ${enq.LastName}`,
  //     'Course Category': enq.Course_Category,
  //     Course: enq.Course_Name,
  //     'Course Fee': enq.Course_Fee,
  //     'Offered Fee': enq.OfferedFee,
  //     'Total Paid Amount': enq.TotalPaidAmount,
  //     'Balance Fee': enq.BalanceFee,
  //     'Paid Amount': enq.PaidAmount,
  //     'Balance on Date': enq.BalanceOnDate,
  //     'Payment Type': enq.PayType,
  //     'Payment Mode': enq.PayMode,
  //     Remarks: enq.Remarks,
  //   }));

  //   const wb = XLSXS.utils.book_new();
  //   const ws = XLSXS.utils.json_to_sheet(data, { origin: 'A8' });
  //   const columns = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P'];
  //   const maxColWidths = {};
  //   const title = 'All Payments Report';

  //   // SETTING UP WIDTH DYNAMICALLY
  //   data.forEach((row) => {
  //     for (const col in row) {
  //       if (Object.prototype.hasOwnProperty.call(row, col)) {
  //         const cellValue = row[col] ? row[col].toString() : '';
  //         maxColWidths[col] = Math.max(maxColWidths[col] || 0, cellValue.length + 15);
  //       }
  //     }
  //   });

  //   const wscols = Object.keys(maxColWidths).map((col) => ({ wch: maxColWidths[col] }));

  //   ws['!cols'] = wscols;

  //   // Merging cells for the title
  //   ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 15 } }];
  //   // Set the title cell's value and styling
  //   ws.A1 = {
  //     v: title,
  //     t: 's',
  //     s: {
  //       font: { bold: true, sz: 16 },
  //       alignment: { horizontal: 'center', vertical: 'center' },
  //       fill: { fgColor: { rgb: 'CCFFCC' } },
  //       border: {
  //         left: { style: 'thin', color: { rgb: '000000' } },
  //         top: { style: 'thin', color: { rgb: '000000' } },
  //         right: { style: 'thin', color: { rgb: '000000' } },
  //         bottom: { style: 'thin', color: { rgb: '000000' } },
  //       },
  //     },
  //   };

  //   ws.C4 = { v: 'Name: ', t: 's', s: { font: { bold: true } } };
  //   ws.D4 = { v: filters.name === '' ? 'ALL Names' : filters.name, t: 's' };

  //   ws.E4 = { v: 'Payment Status: ', t: 's', s: { font: { bold: true } } };
  //   ws.F4 = { v: filters.paymentStatus === '' ? 'ALL' : filters.paymentStatus, t: 's' };

  //   ws.C5 = { v: 'Course Category: ', t: 's', s: { font: { bold: true } } };
  //   ws.D5 = { v: filters.courseCategory === '' ? 'ALL' : filters.courseCategory, t: 's' };

  //   ws.E5 = { v: 'Course: ', t: 's', s: { font: { bold: true } } };
  //   ws.F5 = { v: filters.course === '' ? 'ALL' : filters.course, t: 's' };

  //   ws.C6 = { v: 'From Date: ', t: 's', s: { font: { bold: true } } };
  //   ws.D6 = { v: formatDateDob(fromDate), t: 's' };

  //   ws.E6 = { v: 'To Date: ', t: 's', s: { font: { bold: true } } };
  //   ws.F6 = { v: formatDateDob(toDate), t: 's' };

  //   // headers row styling
  //   const headerRowIndex = '8';
  //   columns.forEach((col) => {
  //     const cell = `${col}${headerRowIndex}`;
  //     // console.log("cell",cell );
  //     ws[cell].s = {
  //       fill: { fgColor: { rgb: 'CCFFCC' } },
  //       alignment: { horizontal: 'center' },
  //       font: { bold: true, sz: 12 },
  //       border: {
  //         left: { style: 'thin', color: { rgb: 'black' } },
  //         top: { style: 'thin', color: { rgb: 'black' } },
  //         right: { style: 'thin', color: { rgb: 'black' } },
  //         bottom: { style: 'thin', color: { rgb: 'black' } },
  //       },
  //     };
  //   });

  //   // excel table contents numbers
  //   const PriceCellStyle = {
  //     alignment: { horizontal: 'right' },
  //     border: {
  //       left: { style: 'thin', color: { rgb: 'black' } },
  //       top: { style: 'thin', color: { rgb: 'black' } },
  //       right: { style: 'thin', color: { rgb: 'black' } },
  //       bottom: { style: 'thin', color: { rgb: 'black' } },
  //     },
  //   };
  //   for (let i = 1; i <= data.length; i += 1) {
  //     const rowNumber = i + 8;
  //     ['H', 'I', 'J', 'K', 'L', 'M'].forEach((col) => {
  //       const cell = `${col}${rowNumber}`;
  //       ws[cell].s = PriceCellStyle;
  //     });
  //   }

  //   // excel table contents strings
  //   const VarCellStyle = {
  //     alignment: { horizontal: 'left' },
  //     border: {
  //       left: { style: 'thin', color: { rgb: 'black' } },
  //       top: { style: 'thin', color: { rgb: 'black' } },
  //       right: { style: 'thin', color: { rgb: 'black' } },
  //       bottom: { style: 'thin', color: { rgb: 'black' } },
  //     },
  //   };
  //   for (let i = 1; i <= data.length; i += 1) {
  //     const rowNumber = i + 8;
  //     ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'N', 'O', 'P'].forEach((col) => {
  //       const cell = `${col}${rowNumber}`;
  //       ws[cell].s = VarCellStyle;
  //     });
  //   }

  //   XLSXS.utils.book_append_sheet(wb, ws, 'Payments Summary');
  //   XLSXS.writeFile(wb, `Payments Summary ${formatDateToinitialValues(new Date())}.xlsx`);
  // };

  // const handleDownloadPDFProfile = () => {
  //   const doc = new JsPDF();
  //   // Define column headers for the PDF table
  //   const headers = [
  //     'S.No',
  //     'Admission ID',
  //     'Admission Date',
  //     'Name',
  //     'Course Category',
  //     'Course',
  //     'Course Fee',
  //     'Offered Fee',
  //     'Total Paid Amount',
  //     'Payment Date',
  //     'Balance Fee',
  //   ];

  //   const data = filteredData.map((enq, index) => ({
  //     'S.No': index + 1,
  //     'Admission ID': enq.Admissionid,
  //     'Admission Date': formatDate(enq.PaymentDate),
  //     Name: `${enq.FirstName} ${enq.LastName}`,
  //     'Course Category': enq.Course_Category,
  //     Course: enq.Course_Name,
  //     Course_Fee: enq.Course_Fee,
  //     OfferedFee: enq.OfferedFee,
  //     TotalPaidAmount: enq.TotalPaidAmount,
  //     PaymentDate: enq.PaymentDate,
  //     BalanceFee: enq.BalanceFee,
  //   }));

  //   // Add table to the PDF document
  //   doc.autoTable({
  //     head: [headers],
  //     body: data.map((row) => Object.values(row)),
  //   });

  //   // Save the PDF with a specific filename
  //   doc.save(`Payments Summary ${formatDateToinitialValues(new Date())}.pdf`);
  // };

  // const handleDownloadPDFAll = (data) => {
  //   const doc = new JsPDF();

  //   const headers = [
  //     'S.No',
  //     'Payment ID',
  //     'Payment Date',
  //     'Admission ID',
  //     'Name',
  //     'Course Category',
  //     'Course',
  //     'Course Fee',
  //     'Offered Fee',
  //     'Total Paid Amount',
  //     'Balance Fee',
  //     'Paid Amount',
  //     'Balance on Date',
  //     'Payment Type',
  //     'Payment Mode',
  //     'Remarks',
  //   ];

  //   const formattedData = filteredData.map((enq, index) => [
  //     index + 1,
  //     enq.PaymentId,
  //     formatDate(enq.PaymentDate),
  //     enq.Admissionid,
  //     `${enq.FirstName} ${enq.LastName}`,
  //     enq.Course_Category,
  //     enq.Course_Name,
  //     enq.Course_Fee,
  //     enq.OfferedFee,
  //     enq.TotalPaidAmount,
  //     enq.BalanceFee,
  //     enq.PaidAmount,
  //     enq.BalanceOnDate,
  //     enq.PayType,
  //     enq.PayMode,
  //     enq.Remarks,
  //   ]);

  //   doc.autoTable({
  //     head: [headers],
  //     body: formattedData,
  //   });

  //   doc.save(`All Payments ${formatDateToinitialValues(new Date())}.pdf`);
  // };

  reportData.forEach((payment) => {
    const fullName = `${payment.FirstName} ${payment.LastName}`;
    if (!groupedPaymentsByName[fullName]) {
      groupedPaymentsByName[fullName] = [];
    }
    groupedPaymentsByName[fullName].push(payment);
  });

  const applyFilters = async () => {
    setOpenLoader(true);
    try {
      const OBid = overall ? styleSelected.Srhid : 0 ;
      const TSid = overall ? 0 : styleSelected.Srhid ;
      const summaryFlag = summary ? 'Y' : 'N' ;
      const res = await axios.instance.get(
        `/getDailyskillmatrix/${TSid}/${operatorSelected.UserAccessID}/${opSelected.OperationId}/${fromDate}/${toDate}/${OBid}/${summaryFlag}`,
        {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        }
      );
      setFilteredData(res.data);
      const totalSum = res.data.reduce((accumulator, obj) => {
        return accumulator + obj.Rate * obj.Qty;
      }, 0);
      if (res.data.length > 0) {
        setTotalSum(totalSum);
      }
      setPage(0);
      setOpenLoader(false);
      setExpanded(false);
      if (res.data.length === 0) {
        setShowNoResultsSnackbar(true);
      } else {
        setShowNoResultsSnackbar(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const downloadPDF = async () => {
    setOpenLoader(true);
    try {
       const OBid = overall ? styleSelected.Srhid : 0 ;
      const TSid = overall ? 0 : styleSelected.Srhid ;
       const summaryFlag = summary ? 'Y' : 'N' ;
      const res = await axios.instance.get(
        `/getDailyskillmatrixpdf/${TSid}/${operatorSelected.UserAccessID}/${opSelected.OperationId}/${fromDate}/${toDate}/${OBid}/${summaryFlag}`,
        {
          responseType: 'blob', // Important: tells axios to handle the response as binary data
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        }
      );
  
      // Create a link element, use it to download the file
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'DailySkillMatrix.pdf'); // Specify the filename
      document.body.appendChild(link);
      link.click();
  
      // Clean up and remove the link
      document.body.removeChild(link);
  
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setOpenLoader(false);
    }
  };

  const handleCloseSnackbar = () => {
    setShowNoResultsSnackbar(false);
  };

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2, p: 1 }} elevation={3}>
        <Snackbar
          style={{ marginTop: '45px' }}
          open={showNoResultsSnackbar}
          autoHideDuration={4000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="info" variant="filled" sx={{ width: '100%' }}>
            {noResultsMessage}
          </Alert>
        </Snackbar>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2} mb={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #134e5e, #71b280)',
              // borderTopRightRadius: '50px',
              // borderBottomRightRadius: '50px',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Daily Skill Matrix Report
            </Typography>
          </Typography>
        </Grid>

        {/* filters */}
        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={handleExpansion}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                <IconButton aria-label="ExpandMoreIcon" color="white">
                  <MastersIcon style={{ color: 'white', width: 24, height: 24 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: '#36BA98',
                    '&.active': {
                      color: 'text.primary',
                      bgcolor: 'action.selected',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                  variant="h6"
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Stack direction={'column'} justifyContent={'space-between'} spacing={2} my={1}>
                <Stack direction={{ sm: 'row', xs: 'column' }} spacing={1}>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="From Date"
                        type="date"
                        value={fromDate}
                        min={'1000-01-01'}
                        max={'9999-12-31'}
                        onChange={(e) => {
                          if (e.target.value) setfromDate(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="To Date"
                        type="date"
                        value={toDate}
                        min={'1000-01-01'}
                        max={'9999-12-31'}
                        onChange={(e) => {
                          if (e.target.value) setToDate(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={[{ StyleDescription: 'All', Srhid: '0' , StyleNumber: '', Line_Name: ''}, ...styleData]}
                          getOptionLabel={(obj) => obj.Srhid !== '0' && obj.Line_Name !== ''
                            ? `${obj.StyleDescription} - ${obj.StyleNumber} - ${obj.Line_Name}` : `${obj.StyleDescription} - ${obj.StyleNumber}`}
                          isOptionEqualToValue={(option, value) => option.StyleDescription === value.StyleDescription}
                          renderInput={(params) => <TextField {...params} label="Style" />}
                          value={styleSelected}
                          onChange={(e, newValue) => {
                            setStyleSelected(newValue);
                             if(newValue.StyleDescription === 'All') 
                                  {setSummaryVisible(false) }
                                else{ setSummaryVisible(true)}
                          }}
                          clearText="Clear"
                          disableClearable
                          disabled={styleVisible}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={2}>
                    <SwitchContainer>
                            <input
                              id={`manufacturerb`}
                              className="checkboxfilter"
                              type="checkbox"
                              checked={overall}
                              disabled={styleVisible}
                              onClick={(e) => {
                                // const newValue = !overall;
                                  setStyleSelected({
                                          Srhid: '0',
                                          StyleDescription: 'Select Style',
                                          StyleNumber: '',
                                          Line_Name: '',
                                        });
                                handleStyleFilter(!overall);
                                setOverall(!overall);
                              }}
                            />{' '}
                            <Label
                              htmlFor='manufacturerb'
                              className=" font_stylechecklable text-dark-emphasis"
                              style={{ color: '#468585' }}
                            >
                              OverAll
                            </Label>
                          </SwitchContainer>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={[{ OperationName: 'All', OperationId: '0' }, ...OperationData]}
                          getOptionLabel={(obj) => obj.OperationName}
                          isOptionEqualToValue={(option, value) => option.OperationId === value.OperationId}
                          renderInput={(params) => <TextField {...params} label="Operations" />}
                          value={opSelected}
                          onChange={(e, newValue) => {
                            setOpSelected(newValue);
                          }}
                          clearText="Clear"
                          disableClearable
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={[{ UserName: 'All', UserAccessID: '0' }, ...OperatorsData]}
                          getOptionLabel={(obj) => obj.UserName}
                          isOptionEqualToValue={(option, value) => option.UserAccessID === value.UserAccessID}
                          renderInput={(params) => <TextField {...params} label="Operators" />}
                          value={operatorSelected}
                          onChange={(e, newValue) => {
                            setOperatorSelected(newValue);
                          }}
                          clearText="Clear"
                          disableClearable
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Stack>

                <Stack direction={{ xs: 'row' }} spacing={1} justifyContent={'flex-end'}>
                  {/* {filteredData.length > 0 && (
                    <Stack direction="row" spacing={1}>
                      {
                        <>
                          <Grow in={filteredData.length > 0}>
                            <Button
                              variant="contained"
                              startIcon={<DownloadForOfflineIcon />}
                              onClick={reportType === 'all' ? handleDownloadExcelaLL : handleDownloadExcelProfileWise}
                              color="success"
                              title="Download as excel"
                              sx={{ color: 'white' }}
                            >
                              Excel
                            </Button>
                          </Grow>
                          <Grow in={filteredData.length > 0}>
                            <Button
                              variant="outlined"
                              startIcon={<PictureAsPdfIcon />}
                              onClick={reportType === 'all' ? handleDownloadPDFAll : handleDownloadPDFProfile}
                              color="error"
                              aria-label="Download as PDF"
                            >
                              PDF
                            </Button>
                          </Grow>
                        </>
                      }
                    </Stack>
                  )} */}
                   <SwitchContainer>
                            <input
                              id={`summary`}
                               className="checkboxfilter"
                              type="checkbox"
                              checked={summary}
                              disabled={summaryVisible}
                              onClick={(e) => {
                                // const newValue = !overall;
                                setSummary(!summary);
                                handlehidevisible()
                                setFilteredData([]);
                              }}
                            />{' '}
                            <Label
                              htmlFor='summary'
                              className=" font_stylechecklable text-dark-emphasis"
                              style={{ color: '#468585' }}
                            >
                              Summary
                            </Label>
                          </SwitchContainer>

                  <Stack direction={'row'} spacing={1}>
                    <Button
                      variant="outlined"
                      startIcon={<PictureAsPdfIcon />}
                      onClick={downloadPDF}
                      color="error"
                      aria-label="Download as PDF"
                    >
                      PDF
                    </Button>
                    <Button variant="contained" color="secondary" onClick={applyFilters} startIcon={<FilterAltIcon />}>
                      Apply Filters
                    </Button>
                    <Button variant="contained" color="warning" onClick={resetFilters} startIcon={<LockResetIcon />}>
                      reset
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Stack>

        <Collapse in={filteredData.length > 0}>
          <>
            {/* table  */}
            <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ padding: 'none' }}>
                    <StyledTableCell>S.No</StyledTableCell>
                    {reportType === 'all' ? (
                      <>
                        {!summary && <StyledTableCell align="center">Date</StyledTableCell> }
                        <StyledTableCell align="left">Operator</StyledTableCell>
                        <StyledTableCell align="left">Operation</StyledTableCell>
                        {!summary && <StyledTableCell align="left">Style</StyledTableCell>}
                        <StyledTableCell align="center">Total Hours</StyledTableCell>
                        <StyledTableCell align="center">Total Pieces</StyledTableCell>
                        {summary && <StyledTableCell align="center">Pcs/Hrs</StyledTableCell> }
                        <StyledTableCell align="center">Min/Pcs</StyledTableCell>
                      </>
                    ) : (
                      <>
                        <StyledTableCell>Date</StyledTableCell>
                        <StyledTableCell>Operator</StyledTableCell>
                        <StyledTableCell>Operation</StyledTableCell>
                        <StyledTableCell>Pcs Rate</StyledTableCell>
                        <StyledTableCell>Qty</StyledTableCell>
                        <StyledTableCell>Amount</StyledTableCell>
                      </>
                    )}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(rowsPerPage > 0
                    ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : filteredData
                  ).map((enq, index) => (
                    <TableRow hover>
                      {reportType === 'all' && (
                        <>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {index + 1}
                          </TableCell>
                         {!summary &&  <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.DailyProddate}
                          </TableCell> }

                          <TableCell
                            align="left"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.OperatorName} <span style={{color:'red'}}>({enq.OperatorGradeName})</span>
                          </TableCell>

                          <TableCell
                            align="left"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.OperationName} <span style={{color:'royalblue'}}>({enq.OperationGradeName})</span>
                          </TableCell>

                         {!summary &&  <TableCell
                            align="left"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            {enq.Style}
                          </TableCell> }

                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            {enq.TotalHrs}
                          </TableCell>

                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.TotalPieces}
                          </TableCell>
                          {summary && <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {Math.round(enq.PcsPerHr)}
                          </TableCell> }
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.PcsPer}
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  ))}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={7} />
                    </TableRow>
                  )} */}
                </TableBody>
              </Table>
            </TableContainer>

            {/* pagination */}
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage} // Use the calculated currentPage value
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0); // Reset the page when rowsPerPage changes
              }}
              mt={2}
            />
          </>
        </Collapse>
      </Container>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default DailySkillMatrix;
